initTextHiddenMore();

// Sbalený text s šipkou pro rozbalení - šipka se zobrazí jen tehdy, pokud se text do sbalených řádků nevejde (styl text-hidden-more-content-collapsed).
function initTextHiddenMore()
{
    document.querySelectorAll('.text-hidden-more-box').forEach(box => {
        var content = box.querySelector('.text-hidden-more-content');
        var button = box.querySelector('.text-hidden-more-show');

        if (content === null || button === null)
        {
            return;
        }

        var toggleButton = () => {
            button.style.display = content.scrollHeight > content.clientHeight ? '' : 'none';
        };

        // Po zúžení okna / otočení telefonu se text může přestat vejít, šipku proto přepočítáme při změně velikosti.
        var resizeObserver = new ResizeObserver(toggleButton);
        resizeObserver.observe(content);

        button.addEventListener('click', event =>
        {
            resizeObserver.disconnect();
            content.classList.remove('text-hidden-more-content-collapsed');
            button.style.display = 'none';
        });
    });
}
